import { Link } from "react-router-dom";

interface VidLinkProps {
  vid: number;
  productId: number;
}

const VidLink = ({ vid, productId }: VidLinkProps) => {
  return (
    <Link
      to={`/community/products/details/${productId}`}
      style={{
        flex: 1,
        textAlign: "center",
        padding: "1em 0",
      }}
    >
      {vid}
    </Link>
  );
};

export default VidLink;
